import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { SalesCreditRolesActions } from "./sales-credit-roles.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// SALES CREDIT ROLES REDUCER (array format for PagesStore)
// **************************************************************************

// Every write endpoint returns the full refreshed list, so create/update/deactivate share one
// handler and no extra refetch is needed.
const loadSuccess = on(
    SalesCreditRolesActions.loadSuccess,
    (state: PagesStore, { salesCreditRoles }) => withSuperUser(state, superUserState => ({
        ...superUserState,
        salesCreditRoles: {
            ...superUserState.salesCreditRoles,
            salesCreditRoles,
            loaded: true,
            error: null,
        },
    })),
);

const mutationSuccess = on(
    SalesCreditRolesActions.createSalesCreditRoleSuccess,
    SalesCreditRolesActions.updateSalesCreditRoleSuccess,
    SalesCreditRolesActions.deactivateSalesCreditRoleSuccess,
    (state: PagesStore, { response }) => withSuperUser(state, superUserState => ({
        ...superUserState,
        salesCreditRoles: {
            ...superUserState.salesCreditRoles,
            salesCreditRoles: response,
            loaded: true,
            error: null,
        },
    })),
);

const invalidate = on(SalesCreditRolesActions.invalidate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    salesCreditRoles: { ...superUserState.salesCreditRoles, loaded: false },
})));

const loadFailure = on(
    SalesCreditRolesActions.loadFailure,
    SalesCreditRolesActions.createSalesCreditRoleFailure,
    SalesCreditRolesActions.updateSalesCreditRoleFailure,
    SalesCreditRolesActions.deactivateSalesCreditRoleFailure,
    (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
        ...superUserState,
        salesCreditRoles: { ...superUserState.salesCreditRoles, error },
    })),
);

export const salesCreditRolesReducer = [
    invalidate,
    loadSuccess,
    mutationSuccess,
    loadFailure,
];
